// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__UXVZj","right":"_type_right__1m14B","left":"_type_left__13Gdp","top":"_type_top__36pXY","bottom":"_type_bottom__XeUKz"};